import { Switch, Route, Redirect } from "react-router-dom";
import Layout1 from "../layouts/backend/layout1";
import BlankLayout from "../layouts/blanklayout";
import SignIn from "../views/backend/auth/signin";
import { firstAllowedPath } from "../components/layout/menu";
import { can, currentSession } from "../utils/roles";

/**
 * Logged-in admin: token and session cached at login. An expired or revoked
 * token is cleared by the session check of the back office (sidebar), which
 * then brings the admin back here.
 */
export const isLoggedIn = () =>
  Boolean(localStorage.getItem("token")) && Boolean(currentSession()._id);

const LayoutsRoute = (props) => {
  return (
    <Switch>
      <Route path="/auth" component={BlankLayout} />
      <Route path="/extra-pages" component={BlankLayout} />
      <Route path="/dashboard" component={Layout1} />
      {/* Sign in page: an admin already logged in goes to their first page */}
      <Route
        path="/"
        render={(props) =>
          isLoggedIn() ? <Redirect to={firstAllowedPath(can)} /> : <SignIn {...props} />
        }
      />
    </Switch>
  );
};

export default LayoutsRoute;
